module.exports = __webpack_public_path__ + "img/women_on_beach_3_mobile.4112c6e4.jpg";